<div class="bg-white min-h-screen">
    <!-- Hero Section -->
    <section
        class="relative bg-gradient-to-b from-[#102B51] via-[#163564] to-[#0D2240] text-white py-16 md:py-24 overflow-hidden">
        <!-- Ambient Glows -->
        <div class="absolute -top-24 -left-24 w-96 h-96 bg-emerald-500/20 rounded-full blur-3xl pointer-events-none">
        </div>
        <div class="absolute top-1/2 -right-24 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl pointer-events-none">
        </div>

        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <div class="max-w-3xl mx-auto text-center space-y-6">
                <!-- Main Heading -->
                <h1
                    class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-tight">
                    Mitra & <span class="text-emerald-400">Kolaborasi Event</span>
                </h1>

                <!-- Subtitle -->
                <p class="text-gray-300 text-sm md:text-base lg:text-lg leading-relaxed max-w-2xl mx-auto">
                    Jadikan event Anda lebih berkesan, interaktif, dan tak terlupakan bersama ekosistem teknologi visual
                    terdepan dari Visidea Studio.
                </p>

                <!-- Action Button -->
                <div class="pt-2 flex flex-wrap items-center justify-center gap-4">
                    <button type="button" (click)="scrollToForm()"
                        class="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-sm md:text-base shadow-md hover:shadow-lg transition-all duration-200 transform hover:-translate-y-0.5 cursor-pointer">
                        <span>Ajukan Kerja Sama Sekarang</span>
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
                        </svg>
                    </button>
                    <a href="https://wa.me/{{phone}}?text=Halo%20Visidea%20Studio,%20saya%20tertarik%20untuk%20kerja%20sama%20Partnership%20/%20Event%20Collaboration.%20Bisa%20dibantu%20informasinya?%20Terima%20kasih!"
                        target="_blank"
                        class="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-[#102B51] hover:bg-[#163564] text-white border border-white/20 font-semibold text-sm md:text-base shadow-md transition-all duration-200 cursor-pointer">
                        <img src="/assets/visidea/whatsapp.png" class="w-4 h-4 brightness-0 invert" alt="WhatsApp">
                        <span>Konsultasi Cepat</span>
                    </a>
                </div>
            </div>
        </div>
    </section>

    <!-- Single Unified Card Section: Event Collaboration & Partnership -->
    <section class="py-12 md:py-16 bg-[#F8FAFC] border-b border-gray-200">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="text-center max-w-2xl mx-auto mb-10 md:mb-12 space-y-3">
                <h2 class="text-2xl sm:text-3xl md:text-4xl font-extrabold text-[#102B51] tracking-tight">
                    Program Kemitraan Visidea Studio
                </h2>
                <p class="text-gray-600 text-sm md:text-base">
                    Pilih skema yang paling sesuai dengan kebutuhan event atau institusi bisnis Anda.
                </p>
            </div>

            <!-- Single Unified Card -->
            <div class="max-w-3xl mx-auto">
                <div (click)="scrollToForm()"
                    class="rounded-3xl p-6 sm:p-9 border-2 border-emerald-500/40 bg-white shadow-xl hover:shadow-2xl transition-all duration-300 cursor-pointer group relative overflow-hidden flex flex-col justify-between">

                    <div class="space-y-6">
                        <div class="flex items-center justify-between">
                            <div
                                class="w-14 h-14 rounded-2xl bg-emerald-50 text-emerald-600 flex items-center justify-center group-hover:scale-105 transition-transform border border-emerald-100">
                                <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z">
                                    </path>
                                </svg>
                            </div>
                            <span class="px-3.5 py-1 bg-emerald-600 text-white text-xs font-bold rounded-full shadow-sm">
                                Dipilih
                            </span>
                        </div>

                        <div>
                            <h3
                                class="text-xl sm:text-2xl font-bold text-gray-900 group-hover:text-emerald-700 transition-colors">
                                Event Collaboration & Partnership
                            </h3>
                            <p class="text-sm text-gray-600 mt-2 leading-relaxed">
                                Kolaborasi interaktif dan kemitraan strategis jangka panjang untuk festival, pensi kampus, wisuda, gathering komunitas, instansi, hingga Event Organizer (EO), Wedding Organizer (WO), Venue, Hotel, & Agensi dengan dukungan ekosistem Photobooth, 360 Video, & Digital Guestbook.
                            </p>
                        </div>

                        <!-- Benefit Checklist -->
                        <div class="grid grid-cols-1 sm:grid-cols-2 gap-2.5 border-t border-gray-100 pt-4 text-xs sm:text-sm text-gray-700">
                            <div class="flex items-center gap-2">
                                <span class="text-emerald-600 font-bold">✓</span>
                                <span>Media Partner & Event Sponsorship</span>
                            </div>
                            <div class="flex items-center gap-2">
                                <span class="text-emerald-600 font-bold">✓</span>
                                <span>Dedicated Partner Rate (Harga Khusus Vendor)</span>
                            </div>
                            <div class="flex items-center gap-2">
                                <span class="text-emerald-600 font-bold">✓</span>
                                <span>Aktivasi Booth Interaktif (Photobooth / 360)</span>
                            </div>
                            <div class="flex items-center gap-2">
                                <span class="text-emerald-600 font-bold">✓</span>
                                <span>Prioritas Jadwal & Technical Crew Siaga</span>
                            </div>
                            <div class="flex items-center gap-2">
                                <span class="text-emerald-600 font-bold">✓</span>
                                <span>Special Bundling & Paket Kolaboratif</span>
                            </div>
                            <div class="flex items-center gap-2">
                                <span class="text-emerald-600 font-bold">✓</span>
                                <span>Co-branding & Integrasi Digital Ecosystem</span>
                            </div>
                        </div>
                    </div>

                    <div class="pt-6">
                        <button type="button" (click)="scrollToForm()"
                            class="w-full py-3.5 px-5 rounded-xl font-bold text-sm transition-all text-center flex items-center justify-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white shadow-md cursor-pointer">
                            <span>Ajukan Event Collaboration & Partnership</span>
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>

<!-- FORM SECTION: Exact Match to the User-Provided Screenshot -->
<section id="partnership-form-section" class="py-16 md:py-24 bg-white">
    <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

        <!-- Heading & Subtitle as seen in the reference image -->
        <div class="text-center max-w-3xl mx-auto mb-12 md:mb-16 space-y-4">
            <h2 class="text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#0E1326] tracking-tight">
                Partnership & Event Collaboration
            </h2>
            <p class="text-gray-600 text-sm sm:text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
                Visidea membuka peluang kolaborasi bagi penyelenggara event yang ingin menciptakan pengalaman
                berkesan melalui berbagai produk kami
            </p>
        </div>

        <!-- Two Columns: Left Image + Right Form (Exact Reference Layout) -->
        <div class="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">

            <!-- Left Column: Official Visidea Partnership Illustration -->
            <div class="lg:col-span-5 flex items-center justify-center">
                <div class="relative w-full max-w-md mx-auto">
                    <img src="/assets/visidea/partnership1.png" alt="Visidea Partnership"
                        class="w-full h-auto object-contain drop-shadow-xl transform hover:scale-[1.02] transition-transform duration-300 select-none">
                </div>
            </div>

            <!-- Right Column: Form matching screenshot fields -->
            <div class="lg:col-span-7">
                <form (ngSubmit)="submitPartnership()" class="space-y-5 max-w-xl mx-auto lg:max-w-none">

                    <!-- 1. Nama Event -->
                    <div>
                        <input type="text" [(ngModel)]="partnershipForm.event_name" name="event_name" required
                            placeholder="Nama Event"
                            class="w-full px-6 py-4 bg-white text-gray-800 placeholder-gray-400 rounded-2xl border-2 border-[#D2D1D1] focus:border-[#102B51] focus:ring-2 focus:ring-blue-100 outline-none transition text-base">
                    </div>

                    <!-- 2. Tanggal & Waktu Event -->
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
                        <div class="relative">
                            <input type="date" [(ngModel)]="partnershipForm.event_date" name="event_date" required
                                max="2050-12-31" placeholder="dd/mm/yyyy" title="Tanggal Event (Maksimal 2050)"
                                class="w-full px-6 py-4 bg-white text-gray-800 placeholder-gray-400 rounded-2xl border-2 border-[#D2D1D1] focus:border-[#102B51] focus:ring-2 focus:ring-blue-100 outline-none transition text-base">
                        </div>
                        <div class="relative">
                            <input type="time" [(ngModel)]="partnershipForm.event_time" name="event_time"
                                placeholder="--:--" title="Waktu Event"
                                class="w-full px-6 py-4 bg-white text-gray-800 placeholder-gray-400 rounded-2xl border-2 border-[#D2D1D1] focus:border-[#102B51] focus:ring-2 focus:ring-blue-100 outline-none transition text-base">
                        </div>
                    </div>

                    <!-- 3. Lokasi Event -->
                    <div>
                        <input type="text" [(ngModel)]="partnershipForm.location" name="location" required
                            placeholder="Lokasi Event"
                            class="w-full px-6 py-4 bg-white text-gray-800 placeholder-gray-400 rounded-2xl border-2 border-[#D2D1D1] focus:border-[#102B51] focus:ring-2 focus:ring-blue-100 outline-none transition text-base">
                    </div>

                    <!-- 4. Jumlah Peserta -->
                    <div>
                        <input type="number" [(ngModel)]="partnershipForm.qty_participant" name="qty_participant"
                            required min="1" placeholder="Jumlah Peserta"
                            class="w-full px-6 py-4 bg-white text-gray-800 placeholder-gray-400 rounded-2xl border-2 border-[#D2D1D1] focus:border-[#102B51] focus:ring-2 focus:ring-blue-100 outline-none transition text-base">
                    </div>

                    <!-- 5. Upload Proposal (PDF) -->
                    <div class="relative">
                        <label
                            class="w-full px-6 py-4 bg-white text-gray-600 rounded-2xl border-2 border-[#D2D1D1] hover:border-[#102B51] focus-within:border-[#102B51] outline-none transition flex items-center gap-3 cursor-pointer">
                            <svg class="w-5 h-5 text-gray-500 shrink-0" fill="none" stroke="currentColor"
                                viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"></path>
                            </svg>
                            <span class="text-base truncate"
                                [ngClass]="selectedFile ? 'text-gray-900 font-semibold' : 'text-gray-400'">
                                {{ selectedFile ? selectedFile.name : 'Upload Proposal (PDF)' }}
                            </span>
                            <input type="file" (change)="onFileChange($event)" accept=".pdf,application/pdf"
                                class="hidden">
                        </label>
                    </div>

                    <!-- 6. Submit Button (Solid Navy Matching Screenshot) -->
                    <div class="pt-2">
                        <button type="submit" [disabled]="isSubmitting"
                            class="w-full py-4 px-6 rounded-2xl bg-[#102B51] hover:bg-[#163564] active:bg-[#0D2240] text-white font-bold text-base tracking-widest uppercase transition-all duration-200 shadow-md hover:shadow-lg flex items-center justify-center gap-2 cursor-pointer disabled:opacity-50">
                            <span *ngIf="!isSubmitting">SUBMIT</span>
                            <span *ngIf="isSubmitting">MENGIRIM...</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>
</div>